var _rect, _rect2, _circle, _circle2, _rect3, _rect4, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionalLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 49,
    viewBox: "0 0 84 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 49,
    rx: 8,
    fill: "#D2DBEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 76,
    height: 41,
    rx: 4,
    fill: "#EFF3F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 24.5,
    r: 8.5,
    stroke: "#3954D0",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 24.5,
    r: 15.5,
    stroke: "#ABBAD8",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23.5,
    width: 37,
    height: 2,
    rx: 1,
    fill: "#ABBAD8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 2,
    rx: 1,
    transform: "matrix(0 -1 -1 0 42.5 43)",
    fill: "#ABBAD8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 24.5,
    r: 2.5,
    fill: "#ABBAD8",
    stroke: "#ABBAD8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionalLight);
export default __webpack_public_path__ + "static/media/directional-light.6477c12ab71ec0044c418b0c7f623ae5.svg";
export { ForwardRef as ReactComponent };